import {
  doc,
  getDoc,
  setDoc,
  deleteDoc,
  serverTimestamp,
} from "firebase/firestore";
import { deleteUser } from "firebase/auth";
import { auth, db } from "../firebase";

// Creates the users/{uid} doc on first sign-in.
// Field shape mirrors fw_mobile/src/lib/users.ts — keep them in sync.
export const ensureUserDoc = async (user) => {
  if (!user) return;
  const ref = doc(db, "users", user.uid);
  const snap = await getDoc(ref);
  if (snap.exists()) return;

  await setDoc(
    ref,
    {
      uid: user.uid,
      email: user.email ?? null,
      displayName: user.displayName ?? null,
      interests: [],
      onboardingDone: false,
      isAdmin: false,
      isClient: false,
      referralJoined: false,
      referralCode: null,
      createdAt: serverTimestamp(),
      updatedAt: serverTimestamp(),
    },
    { merge: true }
  );
};

// Self-serve account deletion. Removes the user's Firestore profile, then the
// Firebase Auth user. Firebase requires a recent sign-in to delete an auth
// user; if it's stale this throws auth/requires-recent-login and the caller
// prompts a re-login. Invoices/transaction records live outside users/{uid}
// and are retained per our policy.
export const deleteAccount = async () => {
  const user = auth.currentUser;
  if (!user) throw new Error("Not signed in.");
  await deleteDoc(doc(db, "users", user.uid));
  await deleteUser(user);
};
